import { Title }     from '@angular/platform-browser';
import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
  providers: [AngularFireDatabase]
})
export class NotificationListComponent implements OnInit {
  @Input() userId : any;
  notifications : Observable<any[]>;
  unread : number = 0;

  constructor(private db : AngularFireDatabase, private title : Title) { }

  ngOnInit() {
    this.notifications =
      this.db.list('activity', ref =>
        ref.orderByChild('ownerId').equalTo(this.userId).limitToLast(15)
      ).snapshotChanges().map(changes => {
          this.unread = 0;
          let activity = changes.map(c => {
            if(c.payload.val().status === 'unread') {
              this.unread += 1;
            }
            return {key: c.key, ...c.payload.val()};
          }).slice().reverse();
          if (this.unread > 0) {
            if (this.title.getTitle().match(/\([0-9]*\)/)) {
              this.title.setTitle(this.title.getTitle().replace(/\([0-9]*\)/, `(${this.unread})`));
            } else {
              this.title.setTitle(this.title.getTitle() + `     (${this.unread})`);
            }
          } else {
            this.title.setTitle(this.title.getTitle().replace(/[\s]*\([0-9]*\)/, ''));
          }
          return activity;
        });
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/activity/notification-list/notification-list.component.ts